import { Card, Col, Container, Row, Table } from "react-bootstrap";

import AnalyticsIcon from "@mui/icons-material/Analytics";
import { AnimatedLine } from "@mui/x-charts/LineChart";
// import { BarChart } from "@mui/x-charts/BarChart";
import { Chip, FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import DashboardCard from "../components/Admin/Reusable/DashboardCard";
import FeedIcon from "@mui/icons-material/Feed";
import LeaderboardIcon from "@mui/icons-material/Leaderboard";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import { LineChart } from "@mui/x-charts/LineChart";
import { Link } from "react-router-dom";
import { PieChart } from "@mui/x-charts/PieChart";
import React, { useEffect, useState } from "react";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { formatDateFull, formatOnlyDate, formattedPrice } from "../utils";

import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import CreditCardOutlinedIcon from "@mui/icons-material/CreditCardOutlined";
import ShoppingBagOutlinedIcon from "@mui/icons-material/ShoppingBagOutlined";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import UnarchiveOutlinedIcon from "@mui/icons-material/UnarchiveOutlined";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import {
  fetchReceiptLastReceipt,
  fetchReceiptMonthlyRevenue,
  fetchReceiptMonthlySales,
  fetchReceiptPendingDeliveries,
  fetchReceiptTotalPrice,
  fetchReceiptTotalPriceDelivery,
  fetchReceiptTotalPriceOnline,
  fetchReceiptTotalSales,
  fetchReceiptTotalSalesDelivery,
  fetchReceiptTotalSalesOnline,
} from "../actions/user";
import { renderDeliveryChip, renderStatusChip } from "../utils/cellRenderTable";

const Dashboard = () => {
  const loggedUserReducer = useSelector((state) => state.loggedUserReducer);
  const dispatch = useDispatch();

  const {
    receiptTotalSales,
    receiptTotalSalesYear,
    receiptTotalSalesOnline,
    receiptTotalSalesDelivery,
    receiptTotalPrice,
    receiptTotalPriceYear,
    receiptTotalPriceOnline,
    receiptTotalPriceDelivery,
    receiptPendingDeliveries,
    receiptMonthlySales,
    receiptMonthlyRevenue,
    receiptLastReceipt,
  } = useSelector((state) => state.userReducer);

  const [selectedYear, setSelectedYear] = useState(2026);
  const years = Array.from({ length: 16 }, (_, i) => 2025 + i);

  useEffect(() => {
    dispatch(fetchReceiptTotalSales());
    dispatch(fetchReceiptTotalSalesOnline());
    dispatch(fetchReceiptTotalSalesDelivery());
    dispatch(fetchReceiptTotalPrice());
    dispatch(fetchReceiptTotalPriceOnline());
    dispatch(fetchReceiptTotalPriceDelivery());
    dispatch(fetchReceiptPendingDeliveries());
    dispatch(fetchReceiptLastReceipt());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchReceiptMonthlySales(selectedYear));
    dispatch(fetchReceiptMonthlyRevenue(selectedYear));

    dispatch(fetchReceiptTotalSales(selectedYear));
    dispatch(fetchReceiptTotalPrice(selectedYear));
  }, [dispatch, selectedYear]);

  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "Maj",
    "Jun",
    "Jul",
    "Avg",
    "Sep",
    "Okt",
    "Nov",
    "Dec",
  ];

  const monthlyChartData = (receiptMonthlySales || []).map((s) => {
    const rev = (receiptMonthlyRevenue || []).find((r) => r.month === s.month);

    return {
      name: `${monthNames[s.month - 1]} 2026`,
      salesCount: s.count || 0,
      revenue: rev?.totalPrice || rev?.revenue || 0, // prilagodi nazivu koji ti backend vraća
    };
  });

  return (
    <div className="dashboard-content-holder">
      <Container fluid>
        <Row>
          <Col lg={12}>
            <h4 className="fs-16 mb-1">
              Dobrodošli, {loggedUserReducer?.loggedUser?.name}{" "}
              {loggedUserReducer?.loggedUser?.surname}!
            </h4>
            <p className="text-muted mb-0">
              Pogledajte aktuelne informacije i ostanite u toku sa svim
              dešavanjima.
            </p>
          </Col>
        </Row>
        <Row className="dashboard-cards-holder mt-3">
          <Col lg={12}>
            <Row>
              <Col lg={3}>
                <DashboardCard
                  number={receiptTotalSales?.count}
                  color={"green-icon"}
                  icon={<ShowChartIcon />}
                  title={`Ukupno prodaja`}
                  link={"/receipt-list"}
                />
              </Col>
              <Col lg={3}>
                <DashboardCard
                  number={receiptTotalSalesOnline?.count}
                  color={"gray-icon"}
                  icon={<PaidOutlinedIcon />}
                  title={`Ukupno prodaja karticom`}
                  link={"/course-list"}
                />
              </Col>
              <Col lg={3}>
                <DashboardCard
                  number={receiptTotalSalesDelivery?.count}
                  color={"blue-icon"}
                  icon={<UnarchiveOutlinedIcon />}
                  title={`Ukupno prodaja pouzećem`}
                  link={"/reels-list"}
                />
              </Col>
              <Col lg={3}>
                <DashboardCard
                  number={receiptPendingDeliveries?.count}
                  color={"gray-icon"}
                  icon={<LocalShippingOutlinedIcon />}
                  title={`Broj porudžbina za dostavu`}
                  link={"/reels-list"}
                />
              </Col>
              <Col lg={3}>
                <DashboardCard
                  number={formattedPrice(receiptTotalPrice?.totalPrice)}
                  color={"green-icon"}
                  icon={<AccountBalanceOutlinedIcon />}
                  title={`Ukupna zarada`}
                  link={"/receipt-list"}
                />
              </Col>
              <Col lg={3}>
                <DashboardCard
                  number={formattedPrice(receiptTotalPriceOnline?.totalPrice)}
                  color={"blue-icon"}
                  icon={<CreditCardOutlinedIcon />}
                  title={`Ukupna zarada karticom`}
                  link={"/course-list"}
                />
              </Col>
              <Col lg={3}>
                <DashboardCard
                  number={formattedPrice(receiptTotalPriceDelivery?.totalPrice)}
                  color={"yellow-icon"}
                  icon={<ShoppingBagOutlinedIcon />}
                  title={`Ukupna zarada pouzećem`}
                  link={"/reels-list"}
                />
              </Col>

              <Col lg={12} className="dashboard-card">
                <Card>
                  <Card.Header>
                    <Card.Title>
                      <small className="text-muted">
                        Poslednjih 5 kupovina
                      </small>
                    </Card.Title>
                  </Card.Header>
                  <Card.Body className="">
                    <Table hover className="mb-0">
                      <thead>
                        <tr>
                          <th>Broj porudžbine</th>
                          <th>Datum kupovine</th>
                          <th>Korisnik</th>
                          <th>Cena</th>
                          <th>Status</th>
                          <th>Status isporuke</th>
                        </tr>
                      </thead>
                      <tbody className="align-middle">
                        {receiptLastReceipt?.map((item, index) => (
                          <tr key={index}>
                            <td>
                              <Link to={`/receipt-edit/${item?.id}`}>
                                #{item?.receiptNumber}
                              </Link>
                            </td>
                            <td>{formatDateFull(item?.createdAt)}</td>
                            <td className="">
                              <div className="d-flex flex-column">
                                <h7>
                                  {item?.name} {item?.surname}
                                </h7>
                              </div>
                            </td>
                            <td>{formattedPrice(item?.totalPrice)}</td>
                            <td>{renderStatusChip(item?.status)}</td>
                            <td>{renderDeliveryChip(item?.deliverStatus)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Card.Body>
                  <Card.Footer>
                    <small className="text-muted">
                      <Link to={"/receipt-list"}>Pogledaj sve kupovine</Link>
                    </small>
                  </Card.Footer>
                </Card>
              </Col>
              <Col lg={12} className="dashboard-card">
                <Card>
                  <Card.Header>
                    <Card.Title className="d-flex align-items-center justify-content-start gap-2">
                      <small className="text-muted">
                        Pregled broja prodaje i zarade za
                      </small>
                      <FormControl>
                        <Select
                          value={selectedYear}
                          onChange={(e) => setSelectedYear(e.target.value)}
                          size="small"
                        >
                          {years.map((year) => (
                            <MenuItem key={year} value={year}>
                              {year}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <small>godinu:</small>
                    </Card.Title>
                  </Card.Header>

                  <Card.Header className="bg-light-subtle p-0 border-bottom-0">
                    <Row className="g-0">
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <div className="dashboard-card-information-item text-center">
                          <h5 class="mb-1">
                            <span class="counter-value" data-target="7585">
                              {formattedPrice(
                                receiptTotalPriceYear?.totalPrice
                              )}
                            </span>
                          </h5>
                          <p class="text-muted mb-0">Ukupna zarada</p>
                        </div>
                      </Col>
                      <Col lg={6} md={6} sm={6} xs={6}>
                        <div className="dashboard-card-information-item text-center">
                          <h5 class="mb-1">
                            <span class="counter-value" data-target="7585">
                              {receiptTotalSalesYear?.count}
                            </span>
                          </h5>
                          <p class="text-muted mb-0">Ukupno prodaja</p>
                        </div>
                      </Col>
                    </Row>
                  </Card.Header>

                  <Card.Body>
                    <ResponsiveContainer width="100%" height={400}>
                      <BarChart
                        data={monthlyChartData}
                        margin={{ left: 20, right: 20, bottom: 40 }}
                      >
                        <XAxis
                          dataKey="name"
                          type="category"
                          tick={{ fill: "#000", fontSize: 12 }}
                          interval={0}
                          angle={-45}
                          textAnchor="end"
                        />

                        {/* Jedna Y osa za prodaje */}
                        <YAxis
                          yAxisId="left"
                          tick={{ fill: "#000", fontSize: 12 }}
                          allowDecimals={false}
                        />

                        {/* Druga Y osa za zaradu (RSD) */}
                        <YAxis
                          yAxisId="right"
                          orientation="right"
                          tick={{ fill: "#000", fontSize: 12 }}
                        />

                        <Tooltip
                          formatter={(value, name) => {
                            if (name === "salesCount")
                              return [value, "Prodaja"];
                            if (name === "revenue")
                              return [`${formattedPrice(value)} RSD`, "Zarada"];
                            return [value, name];
                          }}
                        />

                        {/* Prodaje */}
                        <Bar
                          yAxisId="left"
                          dataKey="salesCount"
                          fill="rgba(41, 156, 219, 0.85)"
                          radius={[4, 4, 0, 0]}
                        />

                        {/* Zarada */}
                        <Bar
                          yAxisId="right"
                          dataKey="revenue"
                          fill="rgba(10, 179, 156, 0.85)"
                          radius={[4, 4, 0, 0]}
                        />
                      </BarChart>
                    </ResponsiveContainer>
                  </Card.Body>
                  <Card.Footer>
                    <small className="text-muted">
                      <Link to={"/receipt-list"}>Pogledaj sve kupovine</Link>
                    </small>
                  </Card.Footer>
                </Card>
              </Col>
            </Row>
          </Col>
          {/* <Col lg={12}>
            <Card>
              <Card.Header>
                <Card.Title>
                  <small className="text-muted">Ukupna zarada</small>
                </Card.Title>
              </Card.Header>
              <Card.Body>
                <LineChart
                  animatedLine={AnimatedLine}
                  height={400}
                  series={[
                    { data: pData, label: "Video" },
                    { data: uData, label: "Kanali" },
                  ]}
                  xAxis={[{ scaleType: "point", data: xLabels2 }]}
                />
              </Card.Body>
            </Card>
          </Col> */}
        </Row>
      </Container>
    </div>
  );
};

export default Dashboard;
